<template>
  <div class="empty-view">
    <img class="empty-image" :src="imagePath" />
    <div class="empty-txt">
      <div class="txt-title">{{ title }}</div>
      <div class="txt-description">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyView',
  props: {
    imagePath: {
      type: String,
      default: require('../assets/images/person/no-learning-content.png')
    },
    title: {
      type: String,
      default: '暂无学习内容'
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.empty-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .empty-image {
    width: 185px;
  }
  .empty-txt {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
    color: #a9a7aa;
    .txt-description {
      margin-top: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EmptyView.vue